import React, { useEffect, useState } from "react";
import styles from "./meetingActions.module.scss";
import { Dropdown, Form, Menu, Modal, Popover, Radio, Select, Tooltip } from "antd";
import { URInputwithLabel } from "../../../../../shared/widgets/inputwithLable";
import { URAvatarGroup } from "../../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../../shared/widgets/avatarGroup/statusDot";
import store from "../../../../../context/store/store";
import { searchActionsHighlight, searchHandler, searchHighlight, searchTranscriptHighlight, toastInformation, userStatusColor } from "../../../../../base/callService/common";
import _ from "lodash";
import { useSelector } from "react-redux";
import { UserDetails } from "../../../../../models/model";
import ContactLoader from "../../../../../styles/images/Lottie Animation.json";
import Lottie from 'lottie-react';
type MeetingActions = {
  download: any;
  allContacts: any;
  favouriteContacts: any;
  searchKey: string;
  shareUrl: string;
  shareContact: any;
  isShareModal: Boolean;
  isDownloadModal: boolean;
  actions:Array<any>;
};


export default function MeetingActions() {
  let { contactReducer }: any = useSelector((state: any) => state);
  let { detailPage, actionsData,searchKey, momLoad, part_MOM } = store.getState().meetingReducer;
  let { workContacts, favContacts } = contactReducer;
  const [index, setIndex] = useState(0);
  const [search,setSearch]=useState("");
  const [getData, setData] = useState<MeetingActions>({
    download: "", allContacts: workContacts, favouriteContacts: favContacts, searchKey: "", shareUrl: "", shareContact: [],
     isShareModal: false, isDownloadModal: false,actions:actionsData
  });


  const keyDownEvent=(e:any)=>{
    console.log(e.keyCode);
    
if(e.keyCode === "ArrowDown"){
  downMove(e);
}
else if(e.keyCode ==="ArrowUp"){
  upMove(e);
}
  }
  var debounce_fun = _.debounce(function () {
    var focusableInputElements: any = document.querySelectorAll(".highlight1");
    if (focusableInputElements?.length > 0) {
      focusableInputElements[0].focus();
      focusableInputElements[0].style.backgroundColor = "#B3D7FA";
      focusableInputElements[0].style.borderBottom = "1px solid #68AFF5";
      var inn: any = document.getElementById('inputBox')
      inn?.focus();
    }
    console.log('Function debounced after 1000ms!');
  }, 1000);

  useEffect(()=>{
    setSearch(searchKey);
    searchActions(searchKey);
    },[searchKey])

    useEffect(()=>{
      setData({ ...getData, actions: actionsData });
    },[actionsData])

    const searchActions=(text:any)=>{
      if (text !== "") {
        let filtered = _.filter(actionsData, function (elem: any) {
          return elem.actions?.toLowerCase().includes(text.toLowerCase()) || elem.name?.toLowerCase().includes(text.toLowerCase())
        });
        
        setData({ ...getData, actions: filtered });
    }
    else {
      setData({ ...getData, actions: actionsData });
    }
    }


  const upMove = (e: any) => {
    let downCountRes: number = index - 1;
    if (index !== 0) {
      var focusableInputElements: any = document.querySelectorAll(".highlight1");
      if (focusableInputElements) {
        let nextIndex = downCountRes;
        e.preventDefault();
        nextIndex = downCountRes;
        focusableInputElements[nextIndex].focus();
        focusableInputElements[nextIndex].style.backgroundColor = "#B3D7FA";
        focusableInputElements[nextIndex].style.borderBottom = "1px solid #68AFF5";
        focusableInputElements[nextIndex + 1].style.backgroundColor = "#FBF4C5";
        focusableInputElements[nextIndex + 1].style.borderBottom = "1px solid #FBE880";
        setIndex(downCountRes);
      }
    }
  }

  const downMove = (e: any) => {

    let downCountRes: number = index + 1;
    if (downCountRes < actionsData.length) {
      var focusableInputElements: any = document.querySelectorAll(".highlight1");
      if (focusableInputElements) {
        let nextIndex = downCountRes;
        e.preventDefault();
        nextIndex = downCountRes;
        focusableInputElements[nextIndex].focus();
        focusableInputElements[nextIndex].style.backgroundColor = "#B3D7FA";
        focusableInputElements[nextIndex].style.borderBottom = "1px solid #68AFF5";
        focusableInputElements[nextIndex - 1].style.backgroundColor = "#FBF4C5";
        focusableInputElements[nextIndex - 1].style.borderBottom = "1px solid #FBE880";
        setIndex(downCountRes)
      }
    }
  }



  let len = Math.round((getData.actions?.length / 8)) > 0 ? getData.actions?.length : 1;
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let actionDataArr = [];
    if (loggedUserDetails?.sip_login_id === detailPage?.sip_id) 
      {
        actionDataArr = getData?.actions?.slice();
      } 
      else 
      {
        let value = detailPage?.participants?.find((elem:any) => {
  
          return elem?.sipid === loggedUserDetails?.sip_login_id
  
          });
        if(value)
        { 
          let data = getData?.actions?.find((elem:any) => {
            return elem?.ext?.toString() === loggedUserDetails?.ext?.toString()
          });
          if (data) actionDataArr?.push(data);
        }
        else
        {
          console.log("can't find the data")
        }
  
      }
  return (
    <>

      <div className={styles.tabsubinnerconsecmain}>

       

          <div className={styles.summarydetailssec}>
            <div className={styles.summarydetailinnermiddle}>
              <div className={styles.middlemainconsec}>
                {actionDataArr && actionDataArr.map((elem: any, i: any) => {
                  let searchh: any = searchActionsHighlight(elem, search)
                  return (

                    <div className={styles.profilelists} key={i}>
                      <div>
                        <URAvatarGroup className={`lefts size32 colorBG${random_color[i]}`}
                          // profileInfo={<><span>{elem?.name?.toUpperCase().charAt(0)}</span><URStatusDot className='stsDotsm green' /></>} />
                          profileInfo={<><span>{elem?.name?.split(' ')?.map((item:any) => item?.charAt(0)?.toUpperCase()).join('')}</span><URStatusDot className='stsDotsm green' /></>} />

                      </div>
                      <div className={styles.middle}>
                        <h4>{elem?.name}
                        {/* <span>{moment(elem.time).format("hh:mm A")}</span> */}
                        </h4>
                        {(searchh?.middleMsg !== "" && search !== "") ?
                          <p>{searchh?.firstMsg}
                            < span className={'highlight1'} tabIndex={index}>{searchh?.middleMsg}</span>{searchh?.lastMsg}</p> : (getData.searchKey  !== "" && searchh?.middleMsg === "") ?
                            <p>{elem?.actions}</p> : <><p>{elem?.actions}</p></>}
                            </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          {
            (part_MOM?.length === 0) && !momLoad && <div className={styles.middlemainconsec}>
              <h4></h4>
              <p className={styles.nodatafound}>No Data Found</p>
            </div>
          }
          {
            part_MOM?.length === 0 && momLoad &&
            <div ><Lottie className="svgLoadinglistcenter" animationData={ContactLoader} /></div>
          }
        
      </div>
    </>
  );
};

